<template>
  <div class="container text-center">
    <div class="row justify-content-center mt-5">
      <div class="col col-lg-9 col-xl-8">
        <div class="card border-0 bg-transparent">
          <div v-if="question.title" class="card-header bg-transparent">
            <h2 class="my-3">{{ question.title }}</h2>
          </div>
          <div class="card-body border border-secondary bg-light">
            <div class="row justify-content-center" style="min-height: 175px">
              <div class="col align-self-center">
                <h4 class="card-text vertical-center">
                  <div v-html="question.body"></div>
                </h4>
              </div>
            </div>
          </div>
          <div class="card-footer bg-transparent">
            <div class="row justify-content-center my-3">
              <div class="col col-sm-9">
                <div class="row">
                  <div class="col">
                    <div class="row justify-content-around my-3">
                      <div class="col col-sm-4" v-for="response in question.responses" :key="response.value">
                        <button type="button" class="btn btn-block text-capitalize" :disabled="isLoading" @click="emitResponse(response.value)">
                          {{ response.text }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row justify-content-around my-3">
                  <div class="col">
                    <div class="progress" style="height: 16px;">
                      <div
                        class="progress-bar progress-bar-striped"
                        role="progressbar"
                        :class="progressBarColor"
                        :style="{ width: progressBarPercent + '%' }"
                        :aria-valuenow="progressBarPercent"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                    <h5 class="mt-4">
                      <fa icon="clock" class="mr-2" />
                      {{ secondsLeft }} {{ $t("seconds") }}
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    question: {
      title: String,
      body: String,
      timeoutInSeconds: Number,
      responses: Array,
    },
    progressBarDelayInMilliseconds: {
      type: Number,
      default: 1000,
    },
  },
  data() {
    return {
      isLoading: false,
      millisecondsLeft: null,
      countdownInterval: null,
      startIntervalTimeout: null,
    };
  },
  computed: {
    millisecondsAllowed() {
      // todo: handle infinite refresh for infinite time
      return this.question.timeoutInSeconds * 1000;
    },
    secondsLeft() {
      return Math.ceil(this.millisecondsLeft / 1000);
    },
    progressBarPercent() {
      return (this.millisecondsLeft / this.millisecondsAllowed) * 100;
    },
    progressBarColor() {
      if (this.progressBarPercent < 34) return "bg-danger";
      if (this.progressBarPercent < 67) return "bg-warning";
      return "bg-success";
    },
  },
  watch: {
    question() {
      this.reset();
    },
  },
  mounted() {
    this.reset();
  },
  methods: {
    reset() {
      this.isLoading = false;
      this.millisecondsLeft = this.millisecondsAllowed;
      if (this.countdownInterval) clearInterval(this.countdownInterval);
      this.startIntervalTimeout = setTimeout(this.startInterval, this.progressBarDelayInMilliseconds); // allows progress animation to "refill"
    },
    startInterval() {
      this.countdownInterval = setInterval(this.onInterval, 100, 100);
    },
    onInterval(interval) {
      if (this.millisecondsLeft === 0) return;
      this.millisecondsLeft -= interval;
      this.millisecondsLeft = Math.max(this.millisecondsLeft, 0);
      if (this.millisecondsLeft === 0) {
        this.isLoading = true;
        this.emitResponse("timeout");
      }
    },
    emitResponse(value) {
      this.isLoading = true;
      if (this.countdownInterval) clearInterval(this.countdownInterval);
      if (this.startIntervalTimeout) clearTimeout(this.startIntervalTimeout);
      this.$emit("response", value);
    },
  },
};
</script>
